import React, { useEffect, useState } from 'react';
import LoginApp from '../LoginApp';
import PageLoader from '../../dashboardApp/components/PageLoader';

export const LoginConfigLoader = () => {
  const [messages, setMessages] = useState();
  const [settings, setSettings] = useState();

  useEffect(() => {
    config();
  }, []);

  const config = async () => {
    await Promise.resolve([
      loadMessages(), loadSettings(),
    ]);
  };

  const loadMessages = async () => {
    const response = await fetch('api/messages/dash.login');
    const messagesLocal = await response.json();
    setMessages(messagesLocal);
  };

  const loadSettings = async () => {
    const response = await fetch('api/settings/theme');
    const settingsLocal = await response.json();
    setSettings(settingsLocal);
  };

  return messages && settings ?
    <LoginApp settings={settings} messages={messages} /> :
    <PageLoader />;
};
